const modSources = [];
export function getModSources() {
    return modSources;
}
export function getModSource(id) {
    return modSources.find((iter) => iter.id === id);
}
export function registerModSource(id, name, onBrowse, options) {
    modSources.push({ id, name, onBrowse, options });
}
